/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetExportReportActivitiesQueryResponse,
  GetExportReportActivitiesQueryParams,
} from '../models/GetExportReportActivities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getExportReportActivitiesQueryResponseSchema } from '../zod/getExportReportActivitiesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getExportReportActivitiesQueryKey = (
  params: GetExportReportActivitiesQueryParams,
) =>
  [
    { url: '/api/export/report/activities' },
    ...(params ? [params] : []),
  ] as const;

export type GetExportReportActivitiesQueryKey = ReturnType<
  typeof getExportReportActivitiesQueryKey
>;

/**
 * {@link /api/export/report/activities}
 */
export async function getExportReportActivities(
  params: GetExportReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetExportReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/export/report/activities`,
    params,
    ...requestConfig,
  });
  return getExportReportActivitiesQueryResponseSchema.parse(res.data);
}

export function getExportReportActivitiesQueryOptions(
  params: GetExportReportActivitiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getExportReportActivitiesQueryKey(params);
  return queryOptions<
    GetExportReportActivitiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetExportReportActivitiesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getExportReportActivities(params, config);
    },
  });
}

/**
 * {@link /api/export/report/activities}
 */
export function useGetExportReportActivities<
  TData = GetExportReportActivitiesQueryResponse,
  TQueryData = GetExportReportActivitiesQueryResponse,
  TQueryKey extends QueryKey = GetExportReportActivitiesQueryKey,
>(
  params: GetExportReportActivitiesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetExportReportActivitiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getExportReportActivitiesQueryKey(params);

  const query = useQuery(
    {
      ...getExportReportActivitiesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
